import { render, staticRenderFns } from "./channelData.vue?vue&type=template&id=32e6280a&scoped=true&"
import script from "./channelData.vue?vue&type=script&lang=js&"
export * from "./channelData.vue?vue&type=script&lang=js&"
import style0 from "./channelData.vue?vue&type=style&index=0&id=32e6280a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e6280a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32e6280a')) {
      api.createRecord('32e6280a', component.options)
    } else {
      api.reload('32e6280a', component.options)
    }
    module.hot.accept("./channelData.vue?vue&type=template&id=32e6280a&scoped=true&", function () {
      api.rerender('32e6280a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataPirate/channelData.vue"
export default component.exports